import { createQueriesConfig } from '@wix/premium-fed-sdk/apis-infra';
import { getIsStudioSiteQueryFn } from './queries/get-is-studio-site.query';
export const StudioSiteQueriesConfig = createQueriesConfig({
  getIsStudioSite: {
    queryFn: getIsStudioSiteQueryFn
  }
});
//# sourceMappingURL=studio-site.queries.js.map